import { Overlay, OverlayConfig, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal, TemplatePortal } from '@angular/cdk/portal';
import { ComponentRef, EmbeddedViewRef, inject, Injectable, TemplateRef, Type, ViewContainerRef } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class RmaOverlayService {
  readonly overlay = inject(Overlay);

  open<T>(
    viewContainerRef: ViewContainerRef | null,
    content: TemplateRef<unknown> | Type<T>,
    config: OverlayConfig,
  ): {
    overlayRef: OverlayRef;
    contentRef: EmbeddedViewRef<unknown> | ComponentRef<T>;
  } {
    const overlayRef = this.overlay.create(config);

    if (content instanceof TemplateRef) {
      const contentRef = overlayRef.attach(
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        new TemplatePortal(content, viewContainerRef!),
      );
      return { overlayRef, contentRef };
    } else {
      const contentRef = overlayRef.attach(new ComponentPortal(content, viewContainerRef));
      return { overlayRef, contentRef };
    }
  }
}
